import { Box, TextField } from '@mui/material';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { z } from 'zod';

import { objectIdSchema } from '@/utils/strings/objectId';

export const AssistantAiResponseFeedbackSchema = z.object({
  conversationItem: objectIdSchema,
  rating: z.enum(['POSITIVE', 'NEGATIVE', 'UNRATED']),
  comment: z.string().min(1, 'Comment is required'),
});

export type AssistantAiResponseFeedbackFormData = z.infer<
  typeof AssistantAiResponseFeedbackSchema
>;

interface Props {
  control: Control<AssistantAiResponseFeedbackFormData>;
}

export const AssistantAiResponseFeedbackForm = ({ control }: Props) => {
  return (
    <Box paddingTop={1}>
      <Controller
        control={control}
        name="comment"
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label="Comment"
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </Box>
  );
};
